import React from 'react';

interface SidebarHeaderProps {
  isDarkMode: boolean;
  collapsed: boolean;
}

const logoBase = 'pt-4 pb-2 flex justify-center items-center h-10 overflow-hidden absolute top-0 left-0 right-0 transition-opacity duration-300 ease-in-out';
const imgStyle = { height: 20, display: 'block', transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)' };

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isDarkMode, collapsed }) => {
  return (
    <>
      <div className={`${logoBase} ${!collapsed ? 'opacity-100' : 'opacity-0'}`}>
        <img
          src={isDarkMode ? '/Logo_Trinis_Basic-white.svg' : '/Logo_Trinis_Basic.svg'}
          alt="TRINIS.EU logo"
          style={imgStyle}
        />
      </div>

      <div className={`${logoBase} ${collapsed ? 'opacity-100' : 'opacity-0'}`}>
        <img
          src="/favicon.svg"
          alt="T"
          style={imgStyle}
        />
      </div>
    </>
  );
};

export default SidebarHeader;
